import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

/**
 * Custom hook to handle all query parameters for the 3D view
 * Centralizes query parameter logic and provides a clean interface
 */
const useQueryParams = (commonProp = true, skuId = null) => {
    const location = useLocation();
    
    const queryParams = useMemo(() => {
        const query = new URLSearchParams(location.search);
        
        return {
            // Core parameters
            sku_id: query.get('sku_id') || skuId,
            bg_id: query.get('bg_id') || null,
            
            // View configuration
            common: query.get('common') === 'true' || commonProp,
            fullControl: query.get('fullControl') === 'true',
            original: query.get('original') === 'true',
            inputView: query.get('input') === 'true',
            
            // Feature toggles
            hotspots: query.get('hotspots') === 'true',
            grids: query.get('grids') === 'true',
            
            // Admin and debugging
            adminView: query.get('admin') === 'true',
            hideAdminPanel: query.get('hideAdminPanel') === 'true',
            hideOverlays: query.get('hideOverlays') === 'true',
        };
    }, [location.search, commonProp, skuId]);

    return queryParams;
};

export default useQueryParams; 